import { createContext } from 'react';
export const SipSocketContext = createContext();
